import React from 'react';
// material-ui

const Logo = (props: {src: string | undefined}) => {
    return <img src={props.src} alt="Berry" width={50} />;
};

export default Logo;
